import React, { Component } from 'react';
// import _ from 'lodash';
import { Button, Input, Tooltip } from 'antd';
import {
  SearchOutlined,
  EditOutlined
  // QuestionCircleOutlined,
  // DeleteOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import {
  // getMasterById,
  getMasterList,
  deleteMaster,
  getUsersList
} from '../../../Utils/FormCalls';
import { connect } from 'react-redux';
import { constant } from '../../../Utils/constants';
import { createStructuredSelector } from 'reselect';
import translation from '../../../Utils/translation';
import { getTranslationCache } from '../../../../../selectors/language';
import themeSettings from '../../../Utils/themeSettings.json';
import ListView from '../../../Utils/ListView';
import { StyledComponent } from '../../../CSS/style';
import { encode as base64_encode } from 'base-64';
import history from '../../../../../commons/history';
const urlList = {
  list: '/api/masterFailureCodes/list',
  getbyId: '/api/masterFailureCodes/getById',
  delete: '/api/masterFailureCodes/delete'
};
// const method = {
//   Method: 'GET'
// };

class FailureCodeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      activeKey: '1',
      form: {},
      userProfile: props && props.userProfile ? props.userProfile : {},
      userList: [],
      translationCache: props.translationCache || [],
      config: {
        viewTypes: ['add', 'card', 'table'],
        defaultViewType: 'table',

        filterType: 'ByAttributeValue',
        attributeList: ['FailureCode', 'Description'],

        firstTitle: 'FailureCode',
        secondTitle: 'CreatedBy',
        thirdTitle: 'CreatedTime',

        actions: ['edit'],
        edit: {
          byAttribute: 'Id',
          redirectURL: '/rubus/AMM/FailureCodeDetails'
        },
        deletee: {
          byAttribute: 'Id'
        }
      }
    };
  }
  componentDidUpdate = async (prevprops) => {
    if (prevprops.translationCache !== this.props.translationCache) {
      this.setState({
        translationCache: this.props.translationCache
      });
    }
    if (this.props.match.params.Masters !== prevprops.match.params.Masters) {
      let mastername = this.props.match.params.Masters;
      this._getAdhocDataSource();
      this.setState({ mastername });
    }
  };
  componentDidMount = async () => {
    this._getAdhocDataSource();
  };
  _getUserList = async () => {
    let userList = await getUsersList();
    this.setState({ userList });
  };
  _getAdhocDataSource = async () => {
    let dataSource = await getMasterList(urlList.list);
    this.setState({
      dataSource,
      activeKey: '1',
      form: {}
    });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={translation(this.props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(this.props.translationCache, 'Search')}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          {translation(this.props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, fontSize: '130%' }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  handleReset = (clearFilters, confirm) => {
    clearFilters();
    this.handleSearch([], confirm);
  };

  downTimeData = (form) => {
    this.setState({
      form
    });
  };
  _deleteById = async (id) => {
    await deleteMaster(urlList.delete, id);
    let dataSource = await getMasterList(urlList.list);
    this.setState({
      dataSource,
      activeKey: '1'
    });
  };
  // deleteMaster = async (id) => {
  //   await deleteMaster(urlList.delete, id);
  //   let dataSource = await getMasterList(urlList.list);
  //   this.setState({
  //     dataSource,
  //     activeKey: '1'
  //     // form: {}
  //   });
  // };
  // changeStatus = async (id) => {
  //     await changeWorkOrderStatus(id)
  //     let dataSource = await getEmergencyWorkOrdersList()
  //     this.setState({
  //         dataSource,
  //         activeKey: "1",
  //         // form: {}
  //     });

  // }
  // editMaster = async (tableRowData) => {
  //   let { form } = this.state;
  //   let data = await getMasterById(urlList.getbyId, tableRowData.Id, method.Method);
  //   let record = data && data !== undefined ? data : {};
  //   _.cloneDeepWith(data, (value) => {
  //     return value !== null && value.InstallationDate && value.CreatedTime
  //       ? {
  //           ...value
  //         }
  //       : _.noop();
  //   });
  //   form = {
  //     ...data
  //   };
  //   this.setState({
  //     activeKey: '2',
  //     status: record && record.Status && record.Status === 'COMP' ? 'Completed' : this.state.status,
  //     form
  //   });
  // };
  _editRecord = async (record) => {
    let { config } = this.state;
    history.push({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };
  render() {
    const { dataSource, userList } = this.state;
    let { translationCache } = this.props;
    let columns = [
      {
        title: translation(translationCache, constant.failureClass),
        dataIndex: 'FailureCode',
        key: 'FailureCode',
        // filter: true,
        ...this.getColumnSearchProps('FailureClass')
      },
      {
        title: translation(translationCache, constant.description),
        dataIndex: 'Description',
        key: 'Description',
        ...this.getColumnSearchProps('Description')
        // "filter": true
      },
      {
        title: translation(translationCache, constant.action),
        width: '600',
        render: (text, record) => (
          <>
            <Button className="ant-btn" onClick={() => this._editRecord(record)} size="middle">
              <Tooltip title={translation(translationCache, 'Edit')}>
                <EditOutlined />
              </Tooltip>
            </Button>
            {/* <Popconfirm
              title="Are you sure that you want to delete the Failure Code Master"
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={() => this._deleteById(record.Id)}
              okText="Yes"
              cancelText="No"
            >
              <Button className="ant-btn" size="middle">
                <span style={{ color: '#ff4d4f' }}>
                  {' '}
                  <DeleteOutlined />
                </span>
              </Button>
            </Popconfirm> */}
          </>
        )
      }
    ];
    let config = {
      title: translation(translationCache, 'Failure Class'),

      viewTypes: ['add', 'card', 'table'],
      defaultViewType: 'table',

      filterType: 'ByAttributeValue',
      attributeList: ['FailureCode', 'Description'],

      firstTitle: 'FailureCode',
      secondTitle: 'CreatedBy',
      thirdTitle: 'CreatedTime',

      actions: ['edit'],
      edit: {
        byAttribute: 'Id',
        redirectURL: '/rubus/AMM/FailureCodeDetails'
      },
      deletee: {
        byAttribute: 'Id'
      }
    };
    return (
      <StyledComponent theme={themeSettings} style={{ minHeight: window.innerHeight - 143 }}>
        <ListView
          columns={columns}
          dataSource={dataSource}
          userList={userList}
          config={config}
          delete={this._deleteById}
        />
      </StyledComponent>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  translationCache: getTranslationCache()
});
export default connect(mapStateToProps)(FailureCodeList);
